const serviceTerms = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: "Welcome to [Your Car Rental Company]! By renting a vehicle from us, you agree to our policies, ensuring a smooth and hassle-free car rental experience."
    },
    { 
        id: "acceptable-use", 
        title: "2. Acceptable Use", 
        content: "Vehicles must be used for lawful purposes only. Off-road driving, racing, subleasing, or any misuse is strictly prohibited."
    },
    { 
        id: "rental-terms", 
        title: "3. Rental Terms", 
        content: "Renters must meet the minimum age requirement and provide a valid driver's license. Rental duration, fuel policy, and mileage limits apply as per the selected plan."
    },
    { 
        id: "user-responsibilities", 
        title: "4. User Responsibilities", 
        content: "Customers must return vehicles on time and in the same condition as rented. Any traffic violations incurred during the rental period are the renter's responsibility."
    },
    { 
        id: "liability", 
        title: "5. Liability & Insurance", 
        content: "Comprehensive insurance is provided with rentals, but renters may be liable for excess charges in case of damages or accidents due to negligence."
    },
    { 
        id: "cancellation", 
        title: "6. Cancellation & Refunds", 
        content: "Cancellation policies vary based on booking type. Refunds may be issued according to our refund policy, with possible charges for late cancellations."
    },
    { 
        id: "vehicle-damage", 
        title: "7. Vehicle Damage Policy", 
        content: "Any damage, excessive wear, or missing accessories will be assessed upon return. Additional charges may apply based on the severity of the damage."
    },
    { 
        id: "governing-law", 
        title: "8. Governing Law", 
        content: "These terms are governed by the laws of [Your Jurisdiction]. Any legal disputes will be handled in the courts of [City/Region]."
    },
    { 
        id: "contact-info", 
        title: "9. Contact Information", 
        content: "For assistance, contact us at support@[companyname].com or call +[Phone Number]."
    }
];

export default serviceTerms;